<template src="./itemsinlist.template.html"></template>
<script>  
    export default {
        name: "itemsinlist",
        props: [],
        data() {
            return {
                items: []
            };
        },
        methods: {

        },
        computed: {},
        watch: {},
        mounted() {
            for (let index = 0; index < 100; index++) {
                this.items.push(index);
            }
        }
    }
</script>